__turbopack_context__.v({
  "container": "_67hujG_container",
  "disabled": "_67hujG_disabled",
  "enlargeOnHover": "_67hujG_enlargeOnHover",
  "highlighted": "_67hujG_highlighted",
  "imageOnTopStyle": "_67hujG_imageOnTopStyle",
  "infoContainer": "_67hujG_infoContainer",
  "leftContainer": "_67hujG_leftContainer",
  "outOfStockTag": "_67hujG_outOfStockTag",
  "priceContainer": "_67hujG_priceContainer",
  "pricePresetTag": "_67hujG_pricePresetTag",
  "productDescription": "_67hujG_productDescription",
  "productMetaContainer": "_67hujG_productMetaContainer",
  "productName": "_67hujG_productName",
  "productPrice": "_67hujG_productPrice",
  "spaceBetween": "_67hujG_spaceBetween",
});
